import { getDate } from '../../office-lab/assets/utils';
import { StatusIndicator } from '@amzn/awsui-components-console';
import React from 'react';
export const LAB_VISIBLE_COLUMNS = [
    { id: 'labId', visible: true },
    { id: 'owner', visible: true },
    { id: 'accessGroup', visible: true },
    { id: 'dotsPoolName', visible: true },
    { id: 'dotsPoolId', visible: true },
    { id: 'monitorEnabled', visible: true },
    { id: 'ticketCategory', visible: true },
    { id: 'ticketType', visible: true },
    { id: 'ticketItem', visible: true },
    { id: 'ticketGroup', visible: true },
    { id: 'lastUpdatedAt', visible: true },
    { id: 'alarmRules', visible: true },
];
export const SORTED_FILED = {
    id: 'lastUpdatedAt',
    header: 'Last updated at',
    cell: (e) => (e.lastUpdatedAt ? getDate(e.lastUpdatedAt) : ''),
    sortingField: 'lastUpdatedAt',
    width: 250,
};
export const LAB_COLUMNS_DEFINITION = [
    {
        id: 'labId',
        header: 'Lab ID',
        cell: (e) => e.LabID,
        width: 200,
    },
    {
        id: 'owner',
        header: 'Owner',
        cell: (e) => e.owner,
        width: 200,
    },
    {
        id: 'accessGroup',
        header: 'Access group',
        cell: (e) => e.accessGroup,
        width: 200,
    },
    {
        id: 'dotsPoolName',
        header: 'Dots pool name',
        cell: (e) => e.dotsPoolName,
        width: 200,
    },
    {
        id: 'dotsPoolId',
        header: 'Dots pool id',
        cell: (e) => e.dotsPoolID,
        width: 150,
    },
    {
        id: 'monitorEnabled',
        header: 'Disconnection monitoring',
        cell: (e) => {
            const status = e.monitorEnabled === undefined ? true : e.monitorEnabled;
            return status ? (
                <StatusIndicator type="success">Enabled</StatusIndicator>
            ) : (
                <StatusIndicator type="stopped">Disabled</StatusIndicator>
            );
        },
        width: 180,
    },
    {
        id: 'ticketCategory',
        header: 'Ticket category',
        cell: (e) => e.Category,
        width: 200,
    },
    {
        id: 'ticketType',
        header: 'Ticket type',
        cell: (e) => e.Type,
        width: 200,
    },
    {
        id: 'ticketItem',
        header: 'Ticket item',
        cell: (e) => e.Item,
        width: 200,
    },
    {
        id: 'ticketGroup',
        header: 'Ticket resolver group',
        cell: (e) => e.Group,
        width: 200,
    },
    SORTED_FILED,
    {
        id: 'alarmRules',
        header: 'Alarm rules',
        cell: (e) => {
            const hasRules = e.alarmRules && e.alarmRules.length > 0;
            return hasRules ? (
                <StatusIndicator type="success">Configured</StatusIndicator>
            ) : (
                <StatusIndicator type="stopped">Not configured</StatusIndicator>
            );
        },
        width: 160,
    },
];
export const COLLECTION_PREFERENCES_PROPS = {
    pageSizePreference: {
        title: 'Select page size',
        options: [
            { value: 20, label: '20 labs' },
            { value: 50, label: '50 labs' },
            { value: 100, label: '100 labs' },
        ],
    },
    contentDisplayPreference: {
        title: 'Select visible columns',
        options: LAB_COLUMNS_DEFINITION.map(({ id, header }) => {
            const option = {
                id,
                label: header,
            };

            if (id === 'labId') {
                option.alwaysVisible = true;
            }

            return option;
        }),
    },
    cancelLabel: 'Cancel',
    confirmLabel: 'Confirm',
    title: 'Preferences',
    stickyColumnsPreference: {
        firstColumns: {
            title: 'Freeze first column(s)',
            description: 'Keep the first column(s) visible while horizontally scrolling the table content.',
            options: [
                { label: 'None', value: 0 },
                { label: 'First column', value: 1 },
            ],
        },
    },
};
